import { Component, OnInit } from '@angular/core';
import { SettingsProvider } from '../_services/settingsProvider.service';


@Component({
  selector: 'complete-self-signup',
  templateUrl: 'complete-self-signup.component.html',
})
export class CompleteSelfSignupComponent implements OnInit {

  constructor(public settings: SettingsProvider) {}
  passwordForm: any;
  ngOnInit(): void {

  }
}
